import { c as _c } from "react/compiler-runtime";
import { FFLogo } from "@repo/ui/components/brand/FFLogo";
import { Avatar, AvatarFallback } from "@repo/ui/components/ui/avatar";
import { Button } from "@repo/ui/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@repo/ui/components/ui/sheet";
import { VisuallyHidden } from "@repo/ui/components/ui/visually-hidden";
import { cn } from "@repo/ui/lib/utils";
import { Link } from "@tanstack/react-router";
import { useAtom } from "jotai";
import { Menu, User } from "lucide-react";
import { authClient } from "@/clients/authClient";
import { mobileSheetOpenAtom } from "@/lib/atoms/nav.atoms";
import { CategorySelect } from "../header/categorySelect";
import { SearchInput } from "./SearchInput";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Logo = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(Link, {
      to: "/",
      className: "mr-10",
      children: /*#__PURE__*/_jsx(FFLogo, {})
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const DesktopUserButton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(Button, {
      variant: "ghost",
      size: "icon",
      className: "hover:bg-branding/20 ml-2 text-white",
      asChild: true,
      children: /*#__PURE__*/_jsx(Link, {
        to: "/mitt-konto",
        children: /*#__PURE__*/_jsx(Avatar, {
          className: "h-8 w-8",
          children: /*#__PURE__*/_jsx(AvatarFallback, {
            children: /*#__PURE__*/_jsx(User, {
              className: "h-4 w-4"
            })
          })
        })
      })
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const DesktopNavigation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsxs("div", {
      className: "hidden items-center gap-2 md:flex",
      children: [/*#__PURE__*/_jsx(CategorySelect, {}), /*#__PURE__*/_jsx(SearchInput, {}), /*#__PURE__*/_jsx(DesktopUserButton, {})]
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const AuthButtons = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(Button, {
      variant: "ghost",
      className: "text-white",
      asChild: true,
      children: /*#__PURE__*/_jsx(Link, {
        to: "/logga-in",
        children: "Logga in"
      })
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-2",
      children: [t0, /*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        asChild: true,
        children: /*#__PURE__*/_jsx(Link, {
          to: "/skapa-konto",
          children: "Skapa konto"
        })
      })]
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const MobileNavigation = t0 => {
  const $ = _c(8);
  const {
    isOpen,
    setIsOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(SheetTrigger, {
      asChild: true,
      children: /*#__PURE__*/_jsx(Button, {
        variant: "ghost",
        size: "icon",
        className: "hover:bg-branding/20 text-white",
        children: /*#__PURE__*/_jsx(Menu, {
          className: "h-6 w-6"
        })
      })
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx(SheetHeader, {
      children: /*#__PURE__*/_jsx(SheetTitle, {
        children: /*#__PURE__*/_jsx(VisuallyHidden, {
          children: "S\xF6k och filtrera"
        })
      })
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(CategorySelect, {});
    t4 = /*#__PURE__*/_jsx(SearchInput, {});
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsxs(SheetContent, {
      side: "top",
      className: "w-full p-4",
      children: [t2, /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col gap-4",
        children: [t3, t4, /*#__PURE__*/_jsx(Button, {
          variant: "outline",
          asChild: true,
          className: "border-branding/20 hover:bg-branding/10 hover:text-branding w-full justify-start",
          children: /*#__PURE__*/_jsxs(Link, {
            to: "/mitt-konto",
            children: [/*#__PURE__*/_jsx(User, {
              className: "mr-2 h-4 w-4"
            }), "Mitt konto"]
          })
        })]
      })]
    });
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isOpen || $[6] !== setIsOpen) {
    t6 = /*#__PURE__*/_jsx("div", {
      className: "md:hidden",
      children: /*#__PURE__*/_jsxs(Sheet, {
        open: isOpen,
        onOpenChange: setIsOpen,
        children: [t1, t5]
      })
    });
    $[5] = isOpen;
    $[6] = setIsOpen;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
const Header = t0 => {
  const $ = _c(24);
  const {
    mode: t1,
    transparent: t2,
    className
  } = t0;
  const mode = t1 === undefined ? "full" : t1;
  const transparent = t2 === undefined ? false : t2;
  const [isOpen, setIsOpen] = useAtom(mobileSheetOpenAtom);
  const {
    data: session
  } = authClient.useSession();
  let t3;
  let t4;
  if ($[0] !== className || $[1] !== mode || $[2] !== session?.user || $[3] !== transparent) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const headerClasses = cn("fixed top-0 z-50 flex w-full items-center p-5", transparent ? "bg-gradient-to-t from-gray-200/0 via-gray-900/25 to-gray-900" : "bg-background/80 backdrop-blur-sm", className);
      if (mode === "minimal") {
        let t5;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = /*#__PURE__*/_jsx(Logo, {});
          $[6] = t5;
        } else {
          t5 = $[6];
        }
        t4 = /*#__PURE__*/_jsx("header", {
          className: headerClasses,
          children: t5
        });
        break bb0;
      }
      if (mode === "auth") {
        let t5;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = /*#__PURE__*/_jsx(Logo, {});
          $[7] = t5;
        } else {
          t5 = $[7];
        }
        let t6;
        if ($[8] !== session?.user) {
          t6 = !session?.user && /*#__PURE__*/_jsx(AuthButtons, {});
          $[8] = session?.user;
          $[9] = t6;
        } else {
          t6 = $[9];
        }
        t4 = /*#__PURE__*/_jsxs("header", {
          className: cn(headerClasses, "justify-between"),
          children: [t5, t6]
        });
        break bb0;
      }
      t3 = cn(headerClasses, "justify-between");
    }
    $[0] = className;
    $[1] = mode;
    $[2] = session?.user;
    $[3] = transparent;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx(Logo, {});
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== session?.user) {
    t6 = session?.user && /*#__PURE__*/_jsx(DesktopNavigation, {});
    $[11] = session?.user;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isOpen || $[14] !== session?.user || $[15] !== setIsOpen) {
    t7 = session?.user && /*#__PURE__*/_jsx(MobileNavigation, {
      isOpen: isOpen,
      setIsOpen: setIsOpen
    });
    $[13] = isOpen;
    $[14] = session?.user;
    $[15] = setIsOpen;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== session?.user) {
    t8 = !session?.user && /*#__PURE__*/_jsx(AuthButtons, {});
    $[17] = session?.user;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = /*#__PURE__*/_jsxs("header", {
      className: t3,
      children: [t5, t6, t7, t8]
    });
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export default Header;